import { Input, Table, TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import AddIcon from "components/Icons/AddIcon";
import useAccount from "hooks/accounts/useAccount";
import { IAccount } from "models/account";
import NextIcon from "components/Icons/NextIcon";
import PreviousIcon from "components/Icons/PreviousIcon";
import { sortIcon, statusBadge } from "components/Table";
import { AccountAlertContextProvider } from "./components/AccountAlertContext";
import Action from "./components/Action";
import { RouteName } from "constants/route";

export default function Account() {
  const {
    data: { data, loading, page, per_page, search, total },
    handleSearch,
    handlePageChange,
  } = useAccount();

  return (
    <AccountAlertContextProvider>
      <div className="w-full">
        <div className="w-full px-6 flex flex-wrap-reverse">
          <div className="grow justify-between items-center flex-wrap-reverse gap-5">
            <Link
              to={RouteName.CREATE_ACCOUNT}
              className="flex items-center p-3 border rounded-lg border-black w-fit gap-x-2"
            >
              <AddIcon />
              <span className="text-black text-sm font-medium">
                Add Account
              </span>
            </Link>
          </div>
          <Input
            className="max-w-72 w-full h-auto px-4 py-2 text-base border border-[rgb(0,0,0,0.1)] rounded-3xl"
            prefix={<SearchOutlined className="mr-2" />}
            placeholder="Search..."
            onChange={handleSearch}
            value={search}
          />
        </div>
        <div className="w-full mt-8 px-4">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            onChange={handlePageChange}
            pagination={{
              total,
              pageSize: per_page,
              current: page,
              nextIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <NextIcon />
                </span>
              ),
              prevIcon: (
                <span className="flex items-center justify-center w-8 h-8 text-2xl">
                  <PreviousIcon />
                </span>
              ),
            }}
          />
        </div>
      </div>
    </AccountAlertContextProvider>
  );
}

const columns: TableColumnsType<IAccount> = [
  {
    title: "First Name",
    dataIndex: "first_name",
    sortIcon,
    sorter: (a, b) => a.first_name.localeCompare(b.first_name),
  },
  {
    title: "Last Name",
    dataIndex: "last_name",
    sortIcon,

    sorter: (a, b) => a.last_name.localeCompare(b.last_name),
  },
  {
    title: "Email",
    dataIndex: "email",
    sortIcon,
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: "Phone",
    sortIcon,
    dataIndex: "phone",
    sorter: (a, b) => a.phone.localeCompare(b.phone),
  },
  {
    title: "Registered By",
    dataIndex: "registered_by_user",
    render: (value?: IAccount) => (
      <p className="capitalize whitespace-nowrap">
        {value ? `${value.first_name} ${value.last_name}` : "-"}
      </p>
    ),
  },
  {
    title: "Role",
    dataIndex: "role",
    sorter: (a, b) => a.role.localeCompare(b.role),
    sortIcon,
    render: (role: string) => (
      <p className="capitalize whitespace-nowrap">
        {role.toLocaleLowerCase().replace("_", " ")}
      </p>
    ),
  },
  {
    title: "Status",
    dataIndex: "is_active",
    sortIcon,
    sorter: (a, b) => Number(a.is_active) - Number(b.is_active),
    render: statusBadge,
  },
  {
    title: "Action",
    render: (value: IAccount) => <Action account={value} />,
  },
];
